import { useEffect } from 'react'
import { installTranslationResilience } from 'translation-resilience'
import { useTranslationResilienceFlags } from './launch-darkly'
import { setTranslationResilienceActive } from './translationResilienceState'

// Installs the DOM-level translate-crash fix behind SHOW_TRANSLATION_RESILIENCE, flagging the
// boundary to stand down so the two mitigations don't overlap during the A/B.
export const TranslationResilience = () => {
  const { SHOW_TRANSLATION_RESILIENCE } = useTranslationResilienceFlags()

  useEffect(() => {
    if (!SHOW_TRANSLATION_RESILIENCE) return
    const uninstall = installTranslationResilience()
    setTranslationResilienceActive(true)
    return () => {
      uninstall()
      setTranslationResilienceActive(false)
    }
  }, [SHOW_TRANSLATION_RESILIENCE])

  return null
}
